import { render, staticRenderFns } from "./MyArqanaHeader.vue?vue&type=template&id=1beba3ce&scoped=true"
import script from "./MyArqanaHeader.vue?vue&type=script&lang=ts"
export * from "./MyArqanaHeader.vue?vue&type=script&lang=ts"
import style0 from "./MyArqanaHeader.vue?vue&type=style&index=0&id=1beba3ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beba3ce",
  null
  
)

export default component.exports